import { render } from "./1.ContactUs.vue?vue&type=template&id=1ffef4ca&scoped=true"
import script from "./1.ContactUs.vue?vue&type=script&lang=js"
export * from "./1.ContactUs.vue?vue&type=script&lang=js"

import "./1.ContactUs.vue?vue&type=style&index=0&id=1ffef4ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffef4ca"]])

export default __exports__